
// @mui material components
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Custom styles for the SidenavItem
import { item, itemContent, itemArrow } from "examples/Sidenav/styles/sidenavItem";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";
import { CommonContext } from "context/CommonCtx";
import { LoginFormContext } from "context/loginFormCtx";
import { useContext } from "react";
import { logout } from "lib/Api/Authentication";
import { clearAllSortByFromCache } from "utils/cacheManager";

function SidenavItem({ 
  color = "info", 
  name, 
  active = false, 
  nested = false, 
  children = false, 
  open = false, 
  ...rest 
}) {
  const [controller] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } = controller;

  const { CCLoader } = useContext(CommonContext);
  const { setUserDetail, handleLogout } = useContext(LoginFormContext);

  const logoutHandler = async () => {
    CCLoader(true);
    setUserDetail([]);
    let response = await logout();
    clearAllSortByFromCache();
    handleLogout();
    CCLoader(false);
  };

  return (
    <>
      <ListItem
        {...rest}
        component="li"
        sx={(theme) => item(theme, { active, color, transparentSidenav, whiteSidenav, darkMode })}
        onClick={() => {
          {
            name === "Logout" && logoutHandler();
          }
        }}
      >
        <MDBox
          sx={(theme) =>
            itemContent(theme, {
              active,
              miniSidenav,
              name,
              open,
              nested,
              transparentSidenav,
              whiteSidenav,
              darkMode,
            })
          }
        >
          <ListItemText primary={name} sx={{
            whiteSpace: "wrap",
          }}/>
          {children && (
            <Icon
              component="i"
              sx={(theme) =>
                itemArrow(theme, { open, miniSidenav, transparentSidenav, whiteSidenav, darkMode })
              }
            >
              expand_less
            </Icon>
          )}
        </MDBox>
      </ListItem>
      {children && (
        <Collapse in={open} timeout="auto" unmountOnExit {...rest}>
          {children}
        </Collapse>
      )}
    </>
  );
}


export default SidenavItem;
